import Navbar from "@/components/site/Navbar";
import Rules from "@/components/site/Rules";
import Footer from "@/components/site/Footer";
import SurvivorGate from "@/components/site/SurvivorGate";

export default function RulesPage() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <main className="pt-[72px]">
        <SurvivorGate label="Rules Handbook">
          <Rules />
        </SurvivorGate>
      </main>
      <Footer />
    </div>
  );
}
